import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const ArrowLeftIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>arrow left</title>
    <polygon points="31.37 8 28.78 8 25.32 8 10.62 23.57 25.32 40 28.78 40 31.37 40 16.67 23.57 31.37 8" />
  </IconBase>
);
